<!-- eslint-disable no-unused-vars -->
<!-- eslint-disable no-unused-vars -->
<template>
    <DxButton @click="refreshAll"></DxButton>

    <div class="h-screen overflow-x-auto overflow-y-hidden">
        <div class="grid h-full">
            <ai-grid-edit-core
                ref="stateVidGridRef"
                :meta="metaFirst"
                :toolbar-config="toolbarConfig3"
                :data-source="stateVidGrid.dataSource"
                :lookups-data="stateVidGrid.lookupDataSource"
                :locked-rows="stateVidGrid.lockedRows"
                @user-data-changed="onUserDataChanged"
                :editing="{ enableDeleting: true, allowAdding: true, allowUpdating: true }"
                @saveClick="onSaveClick"
                @onFocusChanged="onFocusChanged"
                @cellClick="cellClick"
                @refreshClick="refreshClick"
                @user-settings-changed="onUserSettingsChanged"
                @user-settings-reset="onUserSettingsReset"
                :test="stateVidGrid.test"
            >
            </ai-grid-edit-core>
            <ai-grid-edit-core
                ref="stateTypeGridRef"
                :meta="metaSecond"
                :locked-rows="stateTypeGrid.lockedRows"
                :toolbar-config="toolbarConfig1"
                @user-data-changed="onUserDataChanged"
                :lookups-data="stateTypeGrid.lookupDataSource"
                :data-source="stateTypeGrid.dataSource"
                :editing="{ enableDeleting: true, allowAdding: true, allowUpdating: true }"
                @saveClick="onSaveClick"
                @onFocusChanged="onFocusChanged"
                @cellClick="cellClick"
                @refreshClick="refreshClick"
                @user-settings-changed="onUserSettingsChanged"
                @user-settings-reset="onUserSettingsReset"
            >
            </ai-grid-edit-core>
            <ai-grid-edit-core
                ref="stateNominalGridRef"
                :meta="metaNominal"
                :locked-rows="stateNominalGrid.lockedRows"
                :toolbar-config="toolbarConfig2"
                @user-data-changed="onUserDataChanged"
                :lookups-data="stateNominalGrid.lookupDataSource"
                :data-source="stateNominalGrid.dataSource"
                :editing="{ enableDeleting: true, allowAdding: true, allowUpdating: true }"
                @saveClick="onSaveClick"
                @onFocusChanged="onFocusChanged"
                @cellClick="cellClick"
                @refreshClick="refreshClick"
                @user-settings-changed="onUserSettingsChanged"
                @user-settings-reset="onUserSettingsReset"
            >
            </ai-grid-edit-core>
        </div>
    </div>
</template>

<script setup>
import AiGridEditCore from '@/components/ai-grid-edit/ai-grid-edit-core.vue';
import { ref, reactive, onMounted } from 'vue';
import { DxButton } from 'devextreme-vue/button';
// import { meta } from './ai-dependencies-grid-meta';
import { commitDataChanges, getDataSource } from '@/service/meta-service';
import {
    deleteUserDataChanges,
    deleteUserSettingsChanges,
    getUserDataChanges,
    getUserSettingsChanges,
    saveUserDataChanges,
    setUserSettingsChanges,
    // setUserDataChanges,
} from '@/service/userdata-service';
import { meta } from './ai-dependencies-grid-meta';
import { dxUiNotify } from '@/utils/dx-helper';
import AiCustomConfirmDialog from '@/utils/ai-custom-confirm-dialog';
// import { useRoute } from 'vue-router';

// const args = reactive({});
// const route = useRoute();
const isUserDataLoaded = ref(false);
const stateVidGrid = reactive({
    lookupDataSource: {},
    prefState: true,
    selectedRowKeys: [],
    gridChanges: [],
    userSettings: {},
    dataSource: [],
    gridInstance: {},
    lockedRows: [],
    focusedRow: 0,
    keyExpr: 'kod_f23',
    isLoaded: false,
    validationErrorsList: [],
    systemErrorIds: [],
    test: false,
});
const stateVidGridRef = ref();

const stateTypeGrid = reactive({
    lookupDataSource: {},
    prefState: true,
    selectedRowKeys: [],
    gridChanges: [],
    userSettings: {},
    dataSource: [],
    gridInstance: {},
    gridRef: {},
    lockedRows: [],
    focusedRow: 0,
    keyExpr: 'id_test1',
    isLoaded: false,
    validationErrorsList: [],
    systemErrorIds: [],
});
const stateTypeGridRef = ref({});

const stateNominalGrid = reactive({
    lookupDataSource: {},
    prefState: true,
    selectedRowKeys: [],
    gridChanges: [],
    userSettings: {},
    dataSource: [],
    gridInstance: {},
    gridRef: {},
    lockedRows: [],
    focusedRow: 0,
    keyExpr: 'id_ai_grid_edit_100_popup',
    isLoaded: false,
    validationErrorsList: [],
    systemErrorIds: [],
});
const stateNominalGridRef = ref({});
onMounted(async () => {
    isUserDataLoaded.value = false;
    stateVidGrid.gridInstance = stateVidGridRef.value.gridInstance;
    stateTypeGrid.gridInstance = stateTypeGridRef.value.gridInstance;
    stateNominalGrid.gridInstance = stateNominalGridRef.value.gridInstance;
    await setDataSource('core./core/hs-23-select/get', {}, stateVidGrid);
    await fetchAndSetUserData({ viewId: metaFirst.viewId }, stateVidGrid);
    await fetchAndSetUserSettings({ viewId: metaFirst.viewId }, stateVidGrid);

    await fetchAndSetUserData({ viewId: metaSecond.viewId }, stateTypeGrid);
    await fetchAndSetUserData({ viewId: metaNominal.viewId }, stateNominalGrid);

    await fetchAndSetUserSettings({ viewId: metaSecond.viewId }, stateTypeGrid);
    await fetchAndSetUserSettings({ viewId: metaNominal.viewId }, stateNominalGrid);

    const gridTypeState = stateTypeGrid.gridInstance.state();
    const updatedGridTypeState = {
        ...gridTypeState,
        ...stateTypeGrid.userSettings,
        selectedRowKeys: stateTypeGrid.selectedRowKeys,
    };
    stateTypeGrid.gridInstance.state(updatedGridTypeState);
    stateTypeGrid.gridInstance.option('editing.changes', stateTypeGrid.gridChanges);
    const gridNominalState = stateNominalGrid.gridInstance.state();
    const updatedGridNominalState = {
        ...gridNominalState,
        ...stateNominalGrid.userSettings,
        selectedRowKeys: stateNominalGrid.selectedRowKeys,
    };
    stateNominalGrid.gridInstance.state(updatedGridNominalState);
    stateNominalGrid.gridInstance.option('editing.changes', stateNominalGrid.gridChanges);
    isUserDataLoaded.value = true;
});

const fetchAndSetUserSettings = async (args, ds) => {
    const { result, settings } = await getUserSettingsChanges(args);

    if (result && settings) {
        ds.userSettings = settings;
        setPrefState(settings, ds);
    } else {
        ds.userSettings = {};
        ds.prefState = true;
    }
};

const setPrefState = (settings, ds) => {
    if (!settings) {
        ds.prefState = true;
        return;
    }
    switch (settings.preferencesState) {
        case false:
            ds.prefState = false;
            break;
        case undefined:
        case null:
        case true:
        default:
            ds.prefState = true;
            break;
    }
};

// eslint-disable-next-line no-unused-vars
const fetchAndSetUserData = async (args, ds) => {
    const { result, changes } = await getUserDataChanges(args);
    if (result && changes) {
        const { selectedRowKeys, gridChanges, lookupData } = changes;
        ds.selectedRowKeys = selectedRowKeys ? selectedRowKeys : [];
        ds.gridChanges = gridChanges ? gridChanges : [];

        if (lookupData) {
            Object.keys(ds.lookupDataSource).forEach(key => {
                ds.lookupDataSource[key] = [...ds.lookupDataSource[key], ...lookupData];
            });
        }
    }
};

const onUserDataChanged = async (userData, viewId) => {
    if (!isUserDataLoaded.value) return;
    const args = {
        viewId: viewId,
        instanceId: null,
        changes: userData,
    };
    const ds = getStateByComponentName(viewId);
    ds.gridChanges = userData.gridChanges;

    await saveUserDataChanges(args);
    await fetchAndSetUserData({ viewId: viewId }, ds);
    if (viewId) {
        lockAncestors(viewId, userData.gridChanges);
    }
};

const onUserSettingsChanged = async (userSettingsData, metaData) => {
    const ds = getStateByComponentName(metaData.viewId);
    if (!isUserDataLoaded.value) return;
    const args = {
        viewId: metaData.viewId,
        settings: userSettingsData,
    };
    await setUserSettingsChanges(args);
    ds.userSettings = userSettingsData;
    setPrefState(userSettingsData, ds);
};

const onUserSettingsReset = async metaData => {
    const ds = getStateByComponentName(metaData.viewId);
    ds.gridInstance.state({});
    ds.userSettings = {};
    ds.prefState = true;
    await deleteUserSettingsChanges({ viewId: metaData.viewId, settings: {} });
};

// eslint-disable-next-line no-unused-vars
const lockAncestors = (viewId, gridChanges) => {
    // ченджи имеются
    if (gridChanges.length > 0) {
        const ancestors = getAncestorsGrids(viewId);
        ancestors.forEach(ancestor => {
            const ds = getStateByComponentName(ancestor.name);

            // собрала блок строчки
            if (ds.lockedRows.length === 0) {
                ds.lockedRows = ds.dataSource.filter(el => el[ds.keyExpr] !== ds.focusedRow).map(el => el[ds.keyExpr]);
                // тулбар выкл
                ds.gridInstance.option('toolbar').items.forEach(el => {
                    if (el.options) el.options.disabled = true;
                    el.disabled = true;
                });
            }

            // Рекурсивно вызываем lockAncestors для предков

            lockAncestors(ancestor.name, ds.gridChanges);
        });
    } else {
        const ancestors = getAncestorsGrids(viewId);
        ancestors.forEach((ancestor, index) => {
            const ds = getStateByComponentName(ancestor.name);

            // Проверяем, есть ли изменения в этом узле

            // Сбрасываем lockedRows
            if (index === 0 && hasChildrensGridChanges(ancestor.name)) {
                if (ds.lockedRows.length !== 0) {
                    ds.lockedRows = [];
                    // Включаем элементы тулбара
                    ds.gridInstance.option('toolbar').items.forEach(el => {
                        if (el.options) el.options.disabled = false;
                        el.disabled = false;
                    });
                }
            }
            lockAncestors(ancestor.name, ds.gridChanges);
        });
    }
};

// LOOKUPS LOGIC

const setDataSource = async (url, args, ds) => {
    const { result, data } = await getDataSource(url, args);
    ds.lookupDataSource = data ? getLookUpsDs(data) : [];
    ds.dataSource = result ? data : [];
};

const getLookUpsDs = dataSource => {
    const columns = getLookupColumns(dataSource);
    const lookups = {};
    for (const col of columns) {
        const lookupDs = generateLookupDs(col, dataSource);
        lookups[col.dataField] = lookupDs;
    }

    return lookups;
};

const getLookupColumns = metaColumns => {
    const columns = [];
    for (const col of metaColumns) {
        if (col.editor) {
            const isLookupEditor = col.editor.type === 'ai-drop-down' || col.editor.type === 'ai-popup';
            if (isLookupEditor) {
                columns.push(col);
            }
        }
    }
    return columns;
};

const generateLookupDs = (col, ds) => {
    const lookupDs = [];
    for (const row of ds) {
        const lookupRow = {};
        lookupRow[col.dataField] = row[col.dataField];
        lookupRow[col.editor.text] = row[col.editor.text];
        lookupDs.push(lookupRow);
    }
    lookupDs.push({ id_ro_grid_11_popup: 9, name_ro_11: 'hi' });
    return lookupDs;
};

const cellClick = async (componentName, key) => {
    const ds = getStateByComponentName(componentName);
    const isRowDisabled = ds.lockedRows.includes(key);
    if (isRowDisabled) {
        const result = await AiCustomConfirmDialog(
            'Изменение текущей строки заблокировано, \n сохраните или отмените изменения в завсимых компонентах ',
            'Существуют несохраненные данные!',
            false
        );
        if (result === 1) {
            // onSaveClick(processedData);
            return;
        }
        if (result === -1) return;
    }
};
// eslint-disable-next-line no-unused-vars
const refreshClick = async (gridChanges, processedData, metaData) => {
    const ds = getStateByComponentName(metaData.viewId);
    if (gridChanges.length > 0) {
        const result = await AiCustomConfirmDialog('Сохранить изменения?', 'Запрос на сохранение');

        if (result === 1) {
            // onSaveClick(processedData);
            return;
        }
        if (result === -1) return;
    }

    isUserDataLoaded.value = false;
    ds.gridInstance.option('editing.changes', []);
    ds.gridInstance.clearSelection();
    isUserDataLoaded.value = true;

    // systemErrorIds.value = [];
    // validationErrorsList.value = [];
    let currentItem = meta.components.find(el => el.name === metaData.viewId);
    const { result, changes } = await getUserDataChanges({ viewId: metaData.viewId });
    if (result && changes) await deleteUserDataChanges({ viewId: metaData.viewId });

    await fetchAndSetUserData({ viewId: metaData.viewId }, ds);
    await setDataSource(currentItem.selectUrl, {}, ds);

    dxUiNotify('Данные обновлены', 'success');
};

const onSaveClick = async (userChanges, event, metaData) => {
    const ds = getStateByComponentName(metaData.viewId);
    const parentfocusedRow = meta.components.find(el => el.id === metaData.parentComponent);
    const parentDs = getStateByComponentName(parentfocusedRow.name);
    const { errors, validationErrors } = await commitDataChanges(metaData.save, userChanges, {});
    const args = { select_args: { select_args: parentDs.focusedRow + 5 } };
    if (errors.length === 0 && validationErrors.length === 0) {
        await setDataSource(metaData.selectUrl, args, ds);
        ds.gridInstance.option('editing.changes', []);
        dxUiNotify('Изменения данных прошли успешно', 'success');
        return;
    }

    if (validationErrors.length > 0) {
        const validationErrorIds = validationErrors.map(err => err.item.greyEminence);
        ds.validationErrorsList = [...validationErrors];

        const filteredChanges = ds.gridInstance
            .option('editing.changes')
            .filter(change => validationErrorIds.includes(change.key));

        ds.gridInstance.option('editing.changes', filteredChanges);

        await setDataSource(metaData.selectUrl, args);

        dxUiNotify('Validation failed', 'error');
        return;
    }

    if (errors.length > 0) {
        const errorMsgs = [];

        errors.forEach(error => {
            ds.systemErrorIds.push(error.item.greyEminence);
            errorMsgs.push(error.message);
        });

        const filteredChanges = ds.gridInstance
            .option('editing.changes')
            .filter(change => ds.systemErrorIds.includes(change.key));

        ds.gridInstance.option('editing.changes', filteredChanges);

        await setDataSource(metaData.selectUrl, args);
        dxUiNotify('wewe', 'error');
        return;
    }
};

const onFocusChanged = (row, componentName, rowIndex, component) => {
    console.log('onFocusChanged', componentName, rowIndex);
    if (rowIndex === -1) {
        return;
    }
    const children = getAllChildren(componentName);
    const state = getStateByComponentName(componentName);
    state.focusedRow = component.option('focusedRowKey');
    children.forEach(async el => {
        const ds = getStateByComponentName(el.name);

        ds.gridInstance.beginUpdate();
        // ds && (await fetchAndSetUserData({ viewId: componentName }, ds));
        ds && (await setDataSource(el.selectUrl, { select_args: { select_args: rowIndex + 5, componentName } }, ds));

        ds.gridInstance.option('focusedRowIndex', -1);
        ds.gridInstance.option('focusedRowIndex', 0);
        lockAncestors(componentName, ds.gridChanges);
        ds.gridInstance.endUpdate();
    });
};

const hasChildrensGridChanges = componentName => {
    const children = [];
    const currentItem = meta.components.find(el => el.name === componentName);

    const traverseChildren = component => {
        const childComponents = meta.components.filter(item => {
            return item.parentComponent === component.id;
        });
        children.push(...childComponents);
        childComponents.forEach(child => {
            traverseChildren(child);
        });
    };

    if (currentItem) {
        traverseChildren(currentItem);
    }
    const childrenGridChanges = children.filter(el => {
        const ds = getStateByComponentName(el.name);
        return ds.gridChanges.length > 0;
    });
    return childrenGridChanges.length > 0 ? false : true;
};

const getAllChildren = componentName => {
    const children = [];
    let currentItem = meta.components.find(el => el.name === componentName);

    const parent = meta.components.filter(item => {
        return item.parentComponent === currentItem.id;
    });
    if (parent) {
        children.push(...parent);
    }
    return children;
};

const getAncestorsGrids = componentName => {
    let currentItem = meta.components.find(el => el.name === componentName);
    const ancestors = [];
    let currentParentId = currentItem.parentComponent;
    while (currentParentId) {
        const parent = meta.components.find(item => item.id === currentParentId);
        ancestors.push(parent);
        currentParentId = parent.parentComponent;
    }
    return ancestors;
};

const refreshAll = async () => {
    const gc = stateVidGrid.gridChanges;
    const gc1 = stateTypeGrid.gridChanges;
    const gc2 = stateNominalGrid.gridChanges;
    if (gc.length > 0 || gc1.length > 0 || gc2.length > 0) {
        const result = await AiCustomConfirmDialog('Сохранить изменения?', 'Запрос на сохранение');

        if (result === 1) {
            // onSaveClick(processedData);
            return;
        }
        if (result === -1) return;
    }

    isUserDataLoaded.value = false;
    stateVidGrid.gridInstance.option('editing.changes', []);
    stateTypeGrid.gridInstance.option('editing.changes', []);
    stateNominalGrid.gridInstance.option('editing.changes', []);
    stateVidGrid.gridInstance.clearSelection();
    stateTypeGrid.gridInstance.clearSelection();
    stateNominalGrid.gridInstance.clearSelection();
    isUserDataLoaded.value = true;
    let currentItem = meta.components.find(el => el.name === metaFirst.viewId);
    let currentItem1 = meta.components.find(el => el.name === metaSecond.viewId);
    let currentItem2 = meta.components.find(el => el.name === metaNominal.viewId);
    const resp = await getUserDataChanges({ viewId: metaFirst.viewId });
    const resp1 = await getUserDataChanges({ viewId: metaSecond.viewId });
    const resp2 = await getUserDataChanges({ viewId: metaNominal.viewId });
    if (resp.result && resp.changes) await deleteUserDataChanges({ viewId: metaFirst.viewId });
    if (resp1.result && resp1.changes) await deleteUserDataChanges({ viewId: metaSecond.viewId });
    if (resp2.result && resp2.changes) await deleteUserDataChanges({ viewId: metaNominal.viewId });
    await fetchAndSetUserData({ viewId: metaFirst.viewId }, stateVidGrid);
    await fetchAndSetUserData({ viewId: metaSecond.viewId }, stateTypeGrid);
    await fetchAndSetUserData({ viewId: metaNominal.viewId }, stateNominalGrid);
    await setDataSource(currentItem.selectUrl, {}, stateVidGrid);
    await setDataSource(currentItem1.selectUrl, {}, stateTypeGrid);
    await setDataSource(currentItem2.selectUrl, {}, stateNominalGrid);

    dxUiNotify('Данные обновлены', 'success');
};

// const refreshData = async () => {
//     //   const data = await getEoru(route.params.id);
//     //   if (data && data.result) {
//     //     await eoruGrid.value.gridInstance.option('editing.changes', []);
//     //     dataSoure.value = data.data;
//     //     // console.log(eoruGrid.value.gridInstance);
//     //     // eoruGrid.value.gridInstance.refresh();
//     //   }
// };
const getStateByComponentName = componentName => {
    switch (componentName) {
        case 'hs23-view': {
            return stateVidGrid;
        }
        case 'ai-test1': {
            return stateTypeGrid;
        }
        case 'edit-gridpopup': {
            return stateNominalGrid;
        }
    }
};

const toolbarConfig1 = reactive({
    order: [
        {
            name: 'refreshButton',
        },
        {
            name: 'selectButton',
        },
        {
            name: 'copyButton',
        },
        {
            name: 'addRowButton',
        },
        {
            name: 'deleteButton',
        },
        {
            name: 'saveButton',
        },
    ],
});

const toolbarConfig2 = reactive({
    order: [
        {
            name: 'refreshButton',
        },
        {
            name: 'selectButton',
        },
        {
            name: 'copyButton',
        },
        {
            name: 'addRowButton',
        },
        {
            name: 'deleteButton',
        },
        {
            name: 'saveButton',
        },
    ],
});

const toolbarConfig3 = reactive({
    order: [
        {
            name: 'refreshButton',
        },
        {
            name: 'selectButton',
        },
        {
            name: 'copyButton',
        },
        {
            name: 'addRowButton',
        },
        {
            name: 'deleteButton',
        },
        {
            name: 'saveButton',
        },
    ],
});

const metaFirst = reactive({
    keyExpr: 'kod_f23',
    parentComponent: null,
    isFilterPanelVisible: false,
    viewId: 'hs23-view',
    save: 'core./core/hs-23-save/set',
    selectUrl: 'core./core/hs-23-select/get',
    columns: [
        {
            name: 'kod_f23',
            caption: 'kod_f23',
            dataField: 'kod_f23',
            allowEditing: true,
            width: 150,
            index: 1,
            visible: true,
        },
        {
            name: 'name',
            caption: 'name',
            dataField: 'name',
            allowEditing: true,
            width: 150,
            index: 2,
            visible: true,
        },
        {
            name: 'npp',
            caption: 'npp',
            dataField: 'npp',
            allowEditing: true,
            width: 150,
            index: 3,
            visible: true,
        },
        {
            name: 'gr',
            caption: 'gr',
            dataField: 'gr',
            allowEditing: true,
            width: 150,
            index: 4,
            visible: true,
        },
        {
            name: 'pr_byt',
            caption: 'pr_byt',
            dataField: 'pr_byt',
            allowEditing: true,
            width: 150,
            index: 5,
            visible: true,
        },
        {
            name: 'kod_r',
            caption: 'kod_r',
            dataField: 'kod_r',
            allowEditing: true,
            width: 150,
            index: 6,
            visible: true,
        },
        {
            name: 'pr_visible',
            caption: 'pr_visible',
            dataField: 'pr_visible',
            allowEditing: true,
            width: 150,
            index: 7,
            visible: true,
        },
    ],
});

const metaSecond = reactive({
    keyExpr: 'id_test1',
    isFilterPanelVisible: false,
    parentComponent: 1,
    save: 'demo./demo/update_data/grid/put',
    selectUrl: 'demo./demo/ai-test1/select',
    columns: [
        {
            caption: 'ID',
            dataField: 'id_test1',
            allowEditing: false,
        },
        {
            caption: 'Колонка1',
            dataField: 'col1',
        },
        {
            caption: 'Колонка2',
            dataField: 'col2',
        },
        {
            caption: 'Колонка3',
            dataField: 'col3',
        },
    ],
    viewId: 'ai-test1',
});

const metaNominal = reactive({
    keyExpr: 'id_ai_grid_edit_100_popup',
    viewId: 'edit-gridpopup',
    isFilterPanelVisible: false,
    parentComponent: 2,
    save: 'demo./demo/edit-gridpopup-save/set',
    selectUrl: 'demo./demo/edit-gridpopup-select/get',
    columns: [
        {
            name: 'name',
            caption: 'name',
            dataField: 'name',
            allowEditing: true,
            width: 150,
            index: 2,
            visible: true,
        },
        {
            name: 'id_ro_grid_11_popup',
            caption: 'id_ro_grid_11_popup',
            dataField: 'id_ro_grid_11_popup',
            allowEditing: true,
            width: 150,
            index: 3,
            visible: true,
            editor: {
                type: 'ai-popup',
                text: 'name_ro_11',
            },
            component: {
                name: 'ro-grid11popup',
                id: 'id_ro_grid_11_popup',
                text: 'name',
            },
        },
        {
            name: 'id_ro_grid_12_popup',
            caption: 'id_ro_grid_12_popup',
            dataField: 'id_ro_grid_12_popup',
            allowEditing: true,
            width: 150,
            index: 4,
            visible: true,
        },
        {
            name: 'name_ro_11',
            caption: 'name_ro_11',
            dataField: 'name_ro_11',
            allowEditing: 'name_ro_11',
            width: 150,
            index: 5,
            visible: 'name_ro_11',
        },
        {
            name: 'name_ro_12',
            caption: 'name_ro_12',
            dataField: 'name_ro_12',
            allowEditing: 'name_ro_12',
            width: 150,
            index: 6,
            visible: 'name_ro_12',
        },
    ],
});
// const refresh = async (event, componentName) => {
//     console.log(refs[componentName], refs);
//     await refs[componentName].componentRef.refreshClick();
//     const gridChanges = refs[componentName].componentRef.userData.gridChanges;
//     console.log(gridChanges);
//     // lockChangingAncestorsGrids();
// };
</script>
